const STORAGE_KEY = "homeSelectedLocation";

export const DEFAULT_HOME_LOCATION = {
  label: "",
  lat: "23.012649201096547",
  long: "72.51123340677258",
};

export function getSavedHomeLocation() {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...DEFAULT_HOME_LOCATION };
    const parsed = JSON.parse(raw);
    const lat = String(parsed?.lat || "").trim();
    const long = String(parsed?.long || "").trim();
    const label = String(parsed?.label || "").trim();
    if (!lat || !long) return { ...DEFAULT_HOME_LOCATION };
    return {
      label: label || DEFAULT_HOME_LOCATION.label,
      lat,
      long,
    };
  } catch {
    return { ...DEFAULT_HOME_LOCATION };
  }
}

export function hasSavedHomeLocation() {
  try {
    return Boolean(window.localStorage.getItem(STORAGE_KEY));
  } catch {
    return false;
  }
}

export function saveHomeLocation(nextLocation) {
  const lat = String(nextLocation?.lat || "").trim();
  const long = String(nextLocation?.long || "").trim();
  const label = String(nextLocation?.label || "").trim();
  if (!lat || !long) return;
  const payload = {
    lat,
    long,
    label: label || DEFAULT_HOME_LOCATION.label,
  };
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
}
